import { RESET_SURVEY } from './types/global';

export const resetSurvey = () => {
  return {
    type: RESET_SURVEY,
  };
};
